import { Controller } from "@hotwired/stimulus"

// Destination picker for the shared message composer (unified per-person feed).
// The composer is ONE form; selecting a destination just repoints the form's
// action at the chosen existing create endpoint (internal connection_messages,
// or a channel chat) and restyles the chip. The Messages drawer reads
// form.action when it intercepts submit, so no extra wiring is needed.
export default class extends Controller {
    static targets = ["menu", "chip", "chipLabel", "chipIcon"]

    connect() {
        this._onDocClick = (event) => {
            if (!this.element.contains(event.target)) this._close()
        }
        document.addEventListener("click", this._onDocClick)
    }

    disconnect() {
        document.removeEventListener("click", this._onDocClick)
    }

    toggle(event) {
        event.preventDefault()
        if (this.hasMenuTarget) this.menuTarget.classList.toggle("hidden")
    }

    select(event) {
        event.preventDefault()
        const btn = event.currentTarget
        const url = btn.dataset.composerDestinationUrl
        if (url) this.element.action = url
        if (this.hasChipLabelTarget) this.chipLabelTarget.textContent = btn.dataset.composerDestinationLabel || ""
        if (this.hasChipIconTarget) this.chipIconTarget.className = "bi " + (btn.dataset.composerDestinationIcon || "bi-chat")
        if (this.hasChipTarget) this.chipTarget.className = "composer-chip composer-chip--" + (btn.dataset.composerDestinationCss || "internal")
        this._close()
    }

    _close() {
        if (this.hasMenuTarget) this.menuTarget.classList.add("hidden")
    }
}
